import { Component, Input } from "@angular/core";
import { appSettings } from 'src/app/app.settings';

@Component({
  selector: "copyright-block",
  templateUrl: "./copyright.component.html",
  styleUrls: ['./copyright.component.scss'],
  host: {
    class: 'flex flex-wrap gap-x-5 gap-y-2 justify-center'
  }
})
export class CopyrightBlockComponent {

  public currentYear = new Date().getFullYear();
  public mailTo = 'support@lexi.market';

}
